import React, { useEffect } from 'react'
import { HeroSectionOne } from '../../components/hero/HeroSectionOne'
import { Header } from '../../components/header/Header'
import { HeroSectionTwo } from '../../components/hero/HeroSectionTwo'
import { HeroSectionThree } from '../../components/hero/HeroSectionThree'
import { HeroSectionFour } from '../../components/hero/HeroSectionFour'
import { SaveButton } from '../../styles/global'
import { MainSectionOne } from '../../components/main/MainSectionOne'
import { MainSectionTwo } from '../../components/main/MainSectionTwo'
import { MainSectionthree } from '../../components/main/MainSectionthree'
import { GoalSection } from '../../components/goalSection/GoalSection'
import { MainSectionFour } from '../../components/main/MainSectionFour'
import { CallToAction } from '../../components/main/CallToAction'
import { CallToActionOne } from '../../components/main/CallToActionOne'
// import { Accordion } from '../faq/Accordion'
import { Scholarship } from '../../components/schorlarship/Scholarship'
import  Testimonial  from '../../components/testimonial/Testimonial'
import { EarlyAccess } from '../../components/earlyAccess/EarlyAccess'
import { FaqSummary } from '../faq/FaqSummary'
import { Navbar } from '../../components/navbar/Navbar'
import { Footer } from '../../components/footer/Footer'
// import "../../App.css"


interface Props {
  
}

export const Home: React.FC = (): JSX.Element => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
        <Header/>
        <HeroSectionOne/>
        <HeroSectionTwo/>
        <HeroSectionThree/>
        <HeroSectionFour/>
        <div className="coming-soon-btn">
          <SaveButton  to="/">
              Coming Soon
          </SaveButton>
        </div>
        <MainSectionOne/>
        <MainSectionTwo/>
        <GoalSection/>
        <MainSectionthree/>
        <MainSectionFour/>
        <CallToAction/>
        <CallToActionOne/>
        <Scholarship/>
        <Testimonial/>
        <EarlyAccess/>
        <FaqSummary/>


       
        
    </>
  )
}
// (alias) const Home: React.FC

